import {
  Nav,
  NavItem,
  TabContainer,
  TabContent,
  TabPane,
} from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import BookingDotComIcon from 'assets/images/icons/channels/booking.svg?react';
import useFetchPropertyChannelSettings from 'components/domain/channelSettings/useFetchPropertyChannelSettings';
import { Channel } from 'models/Channels';
import {
  CollapseLabel,
  CollapseStyled,
} from '../PropertySettingsReviewsTab.styles';
import { TabContainerChildWrapper } from './BookingDotComQualityScore.styles';
import BookingDotComQualityScoreTabContent from './BookingDotComQualityScoreTabContent';
import BookingDotComQualityScoreTabHeader from './BookingDotComQualityScoreTabHeader';
import usePropertyUidForQualityScore from './usePropertyUidForQualityScore';

const BookingDotComQualityScore = () => {
  const { t } = useTranslation();
  const propertyUid = usePropertyUidForQualityScore();
  const { channelSettings, isFetching } =
    useFetchPropertyChannelSettings(propertyUid);

  const isBookingDotComActive = !!channelSettings?.find(
    ({ enumId }) => enumId === Channel.booking_com,
  )?.isActive;

  if (!isBookingDotComActive || isFetching) {
    return null;
  }

  const title = (
    <CollapseLabel>
      <BookingDotComIcon />
      {t('pageProperty.reviews.bookingDotCom.bookingDotComQualityScore')}
    </CollapseLabel>
  );

  return (
    <CollapseStyled
      variant="card"
      label={title}
      defaultExpanded
      data-testid="bcom-quality-score-section"
    >
      <TabContainer defaultActiveKey="qualityRatingScore">
        <TabContainerChildWrapper>
          <Nav bsStyle="pills" data-testid="bcom-rating-categories">
            <NavItem
              className="rating-category-nav-item"
              eventKey="qualityRatingScore"
            >
              <BookingDotComQualityScoreTabHeader category="qualityRatingScore" />
            </NavItem>
            <NavItem
              className="rating-category-nav-item"
              eventKey="reviewScore"
            >
              <BookingDotComQualityScoreTabHeader category="reviewScore" />
            </NavItem>
            <NavItem
              className="rating-category-nav-item"
              eventKey="contentScore"
            >
              <BookingDotComQualityScoreTabHeader category="contentScore" />
            </NavItem>
            <NavItem
              className="rating-category-nav-item"
              eventKey="workFriendlyScore"
            >
              <BookingDotComQualityScoreTabHeader category="workFriendlyScore" />
            </NavItem>
            <NavItem className="rating-category-nav-item" eventKey="replyScore">
              <BookingDotComQualityScoreTabHeader category="replyScore" />
            </NavItem>
          </Nav>
          <TabContent animation>
            <TabPane eventKey="qualityRatingScore" mountOnEnter unmountOnExit>
              <BookingDotComQualityScoreTabContent category="qualityRatingScore" />
            </TabPane>
            <TabPane eventKey="reviewScore" mountOnEnter unmountOnExit>
              <BookingDotComQualityScoreTabContent category="reviewScore" />
            </TabPane>
            <TabPane eventKey="contentScore" mountOnEnter unmountOnExit>
              <BookingDotComQualityScoreTabContent category="contentScore" />
            </TabPane>
            <TabPane eventKey="workFriendlyScore" mountOnEnter unmountOnExit>
              <BookingDotComQualityScoreTabContent category="workFriendlyScore" />
            </TabPane>
            <TabPane eventKey="replyScore" mountOnEnter unmountOnExit>
              <BookingDotComQualityScoreTabContent category="replyScore" />
            </TabPane>
          </TabContent>
        </TabContainerChildWrapper>
      </TabContainer>
    </CollapseStyled>
  );
};

export default BookingDotComQualityScore;
